define(
//begin v1.x content
({
	invalidMessage: "Ievadītā vērtība nav derīga.",
	missingMessage: "Ir nepieciešama vērtība.",
	rangeMessage: "Šī vērtība ir ārpus diapazona."
})
//end v1.x content
);
